var map = {
	"./bash": 1703,
	"./java": 1704,
	"./json": 1705,
	"./julia": 1706,
	"./python": 1707,
	"./r": 1708,
	"./rust": 1709,
	"./scala": 1710,
	"./shell": 1711,
	"./sql": 1712,
	"./xml": 1713,
	"./yaml": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1702;